import { render, staticRenderFns } from "./orgUserInfo.vue?vue&type=template&id=443883e0&scoped=true"
import script from "./orgUserInfo.vue?vue&type=script&lang=js"
export * from "./orgUserInfo.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./orgUserInfo.vue?vue&type=style&index=1&id=443883e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443883e0",
  null
  
)

export default component.exports